import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { requireRoleGuard } from './guards/role.guard';
import { blockAuthWhenQuestionnaireGuard } from './guards/block-auth-when-questionnaire.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/auth' },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [blockAuthWhenQuestionnaireGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.routes').then((m) => m.HOME_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'payment',
    canActivate: [AuthGuard, requireRoleGuard('organization-owner')],
    loadChildren: () =>
      import('./pages/payment/payment.routes').then((m) => m.PAYMENT_ROUTES),
  },
  {
    path: 'subscription-required',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/subscription-required/subscription-required.component').then(
        (m) => m.SubscriptionRequiredComponent,
      ),
  },
  {
    path: 'subscription-check-unavailable',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/subscription-check-unavailable/subscription-check-unavailable.component').then(
        (m) => m.SubscriptionCheckUnavailableComponent,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./pages/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile-main/profile-main.routes').then(
        (m) => m.PROFMAIN_ROUTES,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'access-fallback',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/access-fallback/access-fallback.component').then(
        (m) => m.AccessFallbackComponent,
      ),
  },
  {
    path: 'forbidden',
    loadComponent: () =>
      import('./pages/forbidden/forbidden.component').then(
        (m) => m.ForbiddenComponent,
      ),
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./pages/maintenance/maintenance.component').then(
        (m) => m.MaintenanceComponent,
      ),
  },
  {
    path: 'docx-editor-test',
    canMatch: [() => environment.enableDocxEditorTestRoute],
    loadComponent: () =>
      import('./pages/docx-editor-test/docx-editor-test.component').then(
        (m) => m.DocxEditorTestComponent,
      ),
  },
  {
    path: 'patient-questionnaire/:token',
    loadComponent: () =>
      import('./pages/patient-questionnaire/patient-questionnaire.component').then(
        (m) => m.PatientQuestionnaireComponent,
      ),
    // No AuthGuard - token validation happens in component
  },
];
